import type { DocumentTypePayload } from '@Application/Documents/DocumentTypes/Actions/documentTypesFetched';

// Same wire shape as a fetched row: the rename endpoint returns the type in full, new label included.
export type DocumentTypeRenamedPayload = DocumentTypePayload;

export type DocumentTypeRenamedAction = {
	type: 'DOCUMENT_TYPE_RENAMED';
	payload: DocumentTypeRenamedPayload;
	accountId: number;
};

export default (payload: DocumentTypeRenamedPayload, accountId: number): DocumentTypeRenamedAction => ({
	type: 'DOCUMENT_TYPE_RENAMED',
	payload,
	accountId,
});
